<script lang="ts">
interface Highlight {
  value: string
  label: FieldLabel
}

const MAX_HL_FIELDS = 3
const FULL_DISPLAY_LEN = 40
const SUMMARY_DISPLAY_WIDTH = 5

export default {
  name: 'UiItemSearchHighlight',
  props: {
    item: {
      type: Object,
    },
    keywords: {
      type: Array,
    },
  },
  setup(props: { item: Item; keywords: string[] }) {
    const { ls, ljoin } = useI18n()
    const dataStore = useDataStore()

    const label = computed(() => {
      if (props.item) return dataStore.label(props.item.common.database)
      return null
    })

    return () => {
      try {
        let ul = h('ul', { class: 'jps-search-highlight' }, [])
        if (label.value && props.keywords?.length > 0) {
          let regxp: RegExp = RegExp(
            '(' +
              props.keywords
                .filter(k => k && !/^-/.test(k))
                .map(k => k.replace(/^"|"$/g, '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
                .join('|') +
              ')',
            'g',
          )
          label.value.fieldLabels.forEach(fld => {
            let value: string = escapeTag(
              ljoin(deepFind2(props.item, fld.path, '')),
            )
            let found: string[] = null
            if (value.length === 0) return
            if ((ul.children?.length as number) >= MAX_HL_FIELDS) return

            let index = 0
            let full = value.length < FULL_DISPLAY_LEN
            const liChildren: any = []

            while ((found = regxp.exec(value)) !== null) {
              let foundLen = regxp.lastIndex - found[0].length
              if (full) {
                liChildren.push(value.substring(index, foundLen))
                liChildren.push(h('em', {}, found[0]))
                index = regxp.lastIndex
              } else {
                let start =
                  regxp.lastIndex - SUMMARY_DISPLAY_WIDTH - found[0].length
                if (start > 0) liChildren.push('...')
                liChildren.push(
                  value.substring(start, start + SUMMARY_DISPLAY_WIDTH),
                )
                liChildren.push(h('em', {}, found[0]))
                liChildren.push(
                  value.substring(
                    regxp.lastIndex,
                    regxp.lastIndex + SUMMARY_DISPLAY_WIDTH,
                  ),
                )
                index = regxp.lastIndex + SUMMARY_DISPLAY_WIDTH
                if (liChildren.length > 12) break
              }
            }
            if (index > 0) {
              if (full) {
                liChildren.push(value.substring(index))
              } else {
                if (index < value.length) liChildren.push('...')
              }
              (ul.children as any[]).push(
                h('li', {}, [
                  h('span', { class: 'highlight-label' }, ls(fld.label)),
                  ...liChildren,
                ]),
              )
            }
          })
        }
        return ul
      } catch (e) {
        console.error(e)
      }
    }
  },
}
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

ul.jps-search-highlight {
  padding-top: 0;
  font-size: small;
  .content & {
    list-style: none;
    margin-left: 0;
    padding-left: 0;
  }
  .highlight-label {
    padding-right: 1em;
    font-weight: bold;
  }
  em {
    background-color: $highlight-yellow;
    display: inline-block;
    padding: 0 0.125rem;
    margin-right: 0.125rem;
    font-weight: bold;
  }
}
</style>
